/**
 * CarFile logo component — uses the actual brand logo images.
 * Supports dark mode (white logo) and light mode (black logo).
 *
 * @param {"sm"|"md"|"lg"|"xl"} size – preset size
 * @param {string} className – additional classes
 */
const sizes = {
  sm: 'h-6',   // 24px — sidebar collapsed
  md: 'h-8',   // 32px — sidebar expanded
  lg: 'h-10',  // 40px — login / hero
  xl: 'h-14',  // 56px — splash
}

const CarFileLogo = ({ size = 'md', className = '', dark = false }) => {
  const src = dark
    ? '/image/carfile_white_logo.webp'
    : '/image/carfile_black_logo.webp'

  return (
    <img
      src={src}
      alt="CarFile"
      className={`${sizes[size] || sizes.md} w-auto ${className}`}
    />
  )
}

export default CarFileLogo
